export const getFreshchatWidgetStyle = () => `
  .mt-fc_frame {
    animation: none !important;
    position: fixed;
  }

  .mt-fc_frame.fc-widget-normal {
    display: none !important;
  }

  .mt-fc_frame.fc-widget-normal.fc-open {
    display: block !important;
    z-index: 9940 !important;
  }

  #fc_frame.h-open-container, #fc_frame.fc-widget-normal.h-open-container {
    width: 376px !important;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 16px 32px 0px !important;
    max-height: calc(100% - 166px) !important;
  }

  .mt-fc_frame.fc-widget-normal.fc-open {
    transition: transform 0.2s ease;
    transform: translateX(0) !important;
  }

  .mt-fc_frame.fc-widget-normal.fc-open.mt-sidebar-expanded {
    transform: translateX(174px) !important;
  }

  #fc_frame.h-open-container.expanded-modal.mt-sidebar-expanded, 
  #fc_frame.fc-widget-small.h-open-container.expanded-modal.mt-sidebar-expanded,
  #fc_frame.fc-widget-normal.h-open-container.expanded-modal.mt-sidebar-expanded {
    left: 80px !important;
    bottom: 16px !important;
  }
`;
